import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import useLocalStorage from "@rehooks/local-storage";
import { ruptureSetReportViewOptions } from "../../constants/ruptureSetDiagnosticReport";
import { SolutionDiagnosticsOption, MetaArguments } from "../../views/GeneralTask/generalTask.types";
import MultiSelect from "../common/MultiSelect";
import RuptureSetImageCard from "./RuptureSetImageCard";

const StyledImageContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  minHeight: "30vh",
}));

interface RuptureSetGeneralViewProps {
  id: string;
  filteredMeta: MetaArguments;
  currentImage: number;
  automationTasksLength: number;
}

const RuptureSetGeneralView: React.FC<RuptureSetGeneralViewProps> = ({
  id,
  filteredMeta,
  currentImage,
  automationTasksLength,
}: RuptureSetGeneralViewProps) => {
  const [generalViews, setGeneralViews] = useLocalStorage<string[]>("ruptureSetGeneralViews");
  const [generalViewSelections, setGeneralViewSelections] = useLocalStorage<SolutionDiagnosticsOption[]>(
    "ruptureSetGeneralViewSelections",
  );

  useEffect(() => {
    const filtered = ruptureSetReportViewOptions.filter((option) => generalViews?.includes(option?.displayName));
    setGeneralViewSelections(filtered || []);
  }, [generalViews]);

  const generalViewDisplayNames: string[] = ruptureSetReportViewOptions.map((option) => option.displayName);

  return (
    <div>
      <MultiSelect
        name="Reports"
        selected={generalViews || []}
        options={generalViewDisplayNames}
        setOptions={setGeneralViews}
      />
      <StyledImageContainer>
        {generalViewSelections?.length
          ? generalViewSelections?.map((option) => (
              <RuptureSetImageCard
                key={option.finalPath}
                id={id}
                option={option}
                currentImage={currentImage}
                automationTasksLength={automationTasksLength}
                filteredMeta={filteredMeta}
              />
            ))
          : null}
      </StyledImageContainer>
    </div>
  );
};

export default RuptureSetGeneralView;
